import classNames from "classnames";

export const cn = (...args: classNames.ArgumentArray) => {
  return classNames(...args);
};
